import EventDetail from './EventDetail';
import { EventDetailProps } from './index';

interface ViewProps {
  content: EventDetailProps;
}

const View = (props: ViewProps) => {
  return <EventDetail content={props.content} />;
};

export default View;
